<template>
    <v-card>
        <v-snackbar v-model="msg" centered>{{ text }}
            <v-btn color="pink" text @click="msg = false"> Close</v-btn>
        </v-snackbar>
        <v-card-title style="background-color: #2b3990" class="white--text pa-4">
            <v-icon class="white--text">mdi-pencil</v-icon> &nbsp;&nbsp;
            <span class="headline" v-html="eventData.name"></span>
        </v-card-title>
        <v-form
            ref="form"
            lazy-validation
        >
            <!--            <v-toolbar :color="eventData.color" dark>-->
            <!--                <v-btn icon>-->
            <!--                    <v-icon>mdi-pencil</v-icon>-->
            <!--                </v-btn>-->
            <!--                <v-toolbar-title v-html="eventData.name"></v-toolbar-title>-->
            <!--                <v-spacer></v-spacer>-->
            <!--            </v-toolbar>-->
            <v-card-text>
                <v-container fluid>

                    <v-row>
                        <v-col class="d-flex" cols="12" md="4">
                            <v-row>
                                <v-col cols="12" lg="12" md="12">
                                    <DatePicker
                                        label="Start Shift"
                                        v-model="startShiftDate"
                                        :default-date="startShiftDateProps"
                                        :isDisabledElemsOnStaff="isDisabledElementsOnStaff()"
                                    />
                                    <TimePicker
                                        v-model="startShiftTime"
                                        labelHour="Start Shift Hour"
                                        labelMinute="Start Shift Minute"
                                        :default-time="startShiftTimeProps"
                                        :isDisabledElemsOnStaff="isDisabledElementsOnStaff()"
                                    />
                                </v-col>
                                <v-col cols="12" lg="12" md="12">
                                    <DatePicker
                                        label="End Shift"
                                        v-model="endShiftDate"
                                        :default-date="endShiftDateProps"
                                        :isDisabledElemsOnStaff="isDisabledElementsOnStaff()"
                                    />
                                    <TimePicker
                                        v-model="endShiftTime"
                                        labelHour="End Shift Hour"
                                        labelMinute="End Shift Minute"
                                        :default-time="endShiftTimeProps"
                                        :isDisabledElemsOnStaff="isDisabledElementsOnStaff()"
                                    />
                                </v-col>
                                <v-container fluid>
                                    <p>Recurring Events?</p>
                                    <v-radio-group v-model="isRecurringEvent" :value="isRecurringEvent" :disabled="isDisabledElementsOnStaff()">
                                        <v-radio label="Yes" value="Yes"></v-radio>
                                        <v-radio label="No" value="No"></v-radio>
                                    </v-radio-group>
                                </v-container>
                                <!-- <v-col cols="6" sm="12" md="6" v-if="isRecurringEvent == 'Yes'">
                                  <v-menu
                                    ref="calendarMenu"
                                    v-model="calendarMenu"
                                    :close-on-content-click="false"
                                    :return-value.sync="date"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        v-model="startDateOfRecurringEvent"
                                        label="Start Date"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        clearable
                                        @change="getAttendance()"
                                      ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="startDateOfRecurringEvent"
                                        no-title
                                        scrollable
                                    >
                                      <v-spacer></v-spacer>
                                      <v-btn text color="primary" @click="calendarMenu = false">
                                        Cancel
                                      </v-btn>
                                      <v-btn text color="primary" @click="$refs.calendarMenu.save(date)">
                                        OK
                                      </v-btn>
                                    </v-date-picker>
                                  </v-menu>
                              </v-col>
                              <v-col cols="6" sm="12" md="6" v-if="isRecurringEvent == 'Yes'">
                                <v-menu
                                  ref="calendar2Menu"
                                  v-model="calendar2Menu"
                                  :close-on-content-click="false"
                                  :return-value.sync="date"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="auto"
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                      v-model="endDateOfRecurringEvent"
                                      label="End Date"
                                      prepend-icon="mdi-calendar"
                                      readonly
                                      v-bind="attrs"
                                      v-on="on"
                                      clearable
                                      @change="getAttendance()"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    v-model="endDateOfRecurringEvent"
                                    no-title
                                    scrollable
                                  >
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="calendar2Menu = false">
                                      Cancel
                                    </v-btn>
                                    <v-btn text color="primary" @click="$refs.calendar2Menu.save(date)">
                                      OK
                                    </v-btn>
                                  </v-date-picker>
                                </v-menu>
                              </v-col> -->

                                <v-col cols="12" md="6" v-if="isRecurringEvent === 'Yes'">
                                    <v-select
                                        :items="optionsForRecurring"
                                        label="More"
                                        v-model="selectedOption"
                                        outlined
                                        :disabled="isDisabledElementsOnStaff()"
                                    ></v-select>
                                </v-col>

                                <!-- <v-container fluid>
                                  <p>Is this for a training?</p>
                                  <v-radio-group
                                    v-model="isForTraining"
                                    :value = "isForTraining"
                                  >
                                    <v-radio
                                      label="Yes"
                                      value="Yes"
                                    ></v-radio>
                                    <v-radio
                                      label="No"
                                      value="No"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-container> -->

                                <!--
                                <v-col class="d-flex" cols="12" sm="12">
                                  <v-autocomplete
                                    v-model="StaffId"
                                    :items="staff"
                                    item-text="Name"
                                    item-value="_id"
                                    label="Staff"
                                    required
                                    :error-messages="staffErrors"
                                    @input="$v.StaffId.$touch()"
                                    @blur="$v.StaffId.$touch()"
                                  ></v-autocomplete>
                                </v-col>
                                -->
                                <v-col class="d-flex" cols="12" sm="12">
                                    <v-autocomplete
                                        v-model="HouseId"
                                        :items="houses"
                                        item-text="Name"
                                        item-value="_id"
                                        label="Program"
                                        required
                                        :error-messages="houseErrors"
                                        @input="$v.HouseId.$touch()"
                                        @blur="$v.HouseId.$touch()"
                                        :disabled="isDisabledElementsOnStaff()"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col class="d-flex" cols="12" sm="12">
                                    <v-select
                                        :items="clientsUnderSelectedProgram"
                                        item-text="Name"
                                        item-value="_id"
                                        label="Client(s)"
                                        v-model="ClientId"
                                        required
                                        :error-messages="clientErrors"
                                        @input="$v.ClientId.$touch()"
                                        @blur="$v.ClientId.$touch()"
                                        :rules="[(value) => (value && value.length > 0) || 'Client(s) is required']"
                                        multiple
                                        @change="getTasks()"
                                        :disabled="isDisabledElementsOnStaff()"
                                    ></v-select>
                                </v-col>
                                <v-col class="d-flex" cols="12" md="12">
                                    <v-select
                                        :items="serviceCodes"
                                        item-text="Name"
                                        item-value="_id"
                                        label="Service Code"
                                        v-model="ServiceCode"
                                        required
                                        :error-messages="ServiceCodeErrors"
                                        @input="$v.ServiceCode.$touch()"
                                        @blur="$v.ServiceCode.$touch()"
                                        :disabled="isDisabledElementsOnStaff()"
                                    />
                                </v-col>
                                <v-col cols="12" md="12">
                                    <v-textarea
                                        v-model="notes"
                                        outlined
                                        label="Notes"
                                        value=""
                                        :disabled="isDisabledElementsOnStaff()"
                                    ></v-textarea>
                                </v-col>

                            </v-row>
                        </v-col>
                        <v-col class="d-flex" cols="12" md="4">
                            <v-container fluid>
                                <v-radio-group v-model="task">
                                    <template v-slot:label>
                                        <h3 class="text-center"><strong>Assign Task</strong></h3>
                                    </template>
                                    <v-container v-for="task in tasks" :key="task._id">
                                        <v-radio :value="task.Event" :disabled="isDisabledElementsOnStaff()">
                                            <template v-slot:label>
                                                <span>{{ task.Event }}</span>
                                            </template>
                                        </v-radio>
                                    </v-container>
                                </v-radio-group>
                            </v-container>
                        </v-col>
                        <v-col class="d-flex" cols="12" md="4">
                            <!--PUT THE ADDITIONAL INFORMATION--->
                            <v-col cols="12" md="12" v-if="isShowing">
                                <v-card class="" max-width="">
                                    <v-list class="overflow-y-auto" height="">
                                        <v-subheader>
                                            <h3>Assigned Staff</h3>
                                        </v-subheader>
                                        <v-list-item>
                                            <v-list-item-title :style="{ color: staffRequiresSupervision ? 'red' : '' }">
                                                {{ staffName }}
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-card>
                                <v-card class="mt-3 pa-4 overflow-y-auto overflow-x-auto" height="35vh">
                                    <v-card-title>Available</v-card-title>
                                    <v-divider></v-divider>
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                        v-model="search"
                                        clearable
                                        flat
                                        solo-inverted
                                        hide-details
                                        prepend-inner-icon="search"
                                        label="search"
                                        class="desktop"
                                    ></v-text-field>
                                    <v-spacer></v-spacer>
                                    <v-container fluid>
                                        <v-radio-group
                                            v-model="staffSelected"
                                            :rules="[v => !!v || 'Staff is required']"
                                            required
                                            :disabled="isDisabledElementsOnStaff()"
                                            @change="checkSupervision"
                                        >
                                            <div v-for="available in resultQueryStaff"
                                                 :key="available._id"
                                            >
                                                <v-radio :value="available" class="mb-6">
                                                    <template v-slot:label>
                                                        <div :style="{ color: available.RequiresSupervision ? 'red' : '' }">
                                                            {{ available.Name }}
                                                            <v-icon v-if="available.MedCertified" small>verified_user
                                                            </v-icon>
                                                            <v-icon v-if="available.FirstAid" small>local_hospital
                                                            </v-icon>

                                                            <v-icon small style="position: absolute;right: 0;">
                                                                mdi-phone
                                                            </v-icon>
                                                        </div>
                                                    </template>
                                                </v-radio>
                                            </div>
                                        </v-radio-group>
                                    </v-container>
                                </v-card>
                                <v-card class="mt-3 pa-2" max-width="">
                                    <v-list class="overflow-y-auto" height="40vh">
                                        <v-subheader>
                                            <h3>Schedule in this Date</h3>
                                        </v-subheader>
                                        <v-list-item
                                            v-for="(schedule, i) in scheduledStaff"
                                            :key="i"
                                            :value="schedule.staffId"
                                        >
                                            <v-list-item-title
                                                :style="{ color: schedule.staffRequiresSupervision ? 'red' : '' }"
                                                v-text="schedule.staffName">
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-card>
                            </v-col>
                        </v-col>

                        <!-- <v-col class="d-flex" cols="12" md="4" v-if="isForTraining == 'Yes' ">
                          <v-col cols="12" md="12" v-if="isShowing">
                            <v-card class="" max-width="">
                              <v-list class="overflow-y-auto" height="">
                                <v-subheader>
                                  <h3>Assigned Staff</h3>
                                </v-subheader>
                                <v-list-item>
                                  <v-list-item-title v-text="staffName"></v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-card>
                            <v-select
                                class="my-0 mt-9"
                                v-model="HouseId"
                                :items="houses"
                                item-text="Name"
                                item-value="_id"
                                label="Filter available staff by Program"
                              ></v-select>
                            <v-card class="my-0 pa-4 overflow-y-auto overflow-x-auto" height="35vh">
                              <v-card-title>Available</v-card-title>
                              <v-divider></v-divider>
                              <v-spacer></v-spacer>
                              <v-text-field
                                v-model="search"
                                clearable
                                flat
                                solo-inverted
                                hide-details
                                prepend-inner-icon="search"
                                label="search"
                                class="desktop"
                              ></v-text-field>
                              <v-spacer></v-spacer>
                              <v-container fluid>
                                <v-radio-group
                                  v-model="staffSelected"
                                >
                                  <div v-for="available in resultQueryStaffTraining"
                                    :key="available._id"
                                  >
                                    <v-radio :value="available._id" class="mb-6">
                                      <template v-slot:label>
                                        <div>{{ available.Name }}
                                          <v-icon v-if="available.MedCertified" small >verified_user</v-icon>
                                          <v-icon v-if="available.FirstAid" small >local_hospital</v-icon>

                                          <v-icon small style="position: absolute;right: 0;">mdi-phone</v-icon>
                                        </div>
                                      </template>
                                    </v-radio>
                                  </div>
                                </v-radio-group>
                              </v-container>
                            </v-card>
                            <v-card class="mt-3 pa-2" max-width="">
                              <v-list class="overflow-y-auto" height="40vh">
                                <v-subheader>
                                  <h3>Schedule in this Date</h3>
                                </v-subheader>
                                <v-list-item
                                  v-for="(schedule, i) in scheduledStaffinTraining"
                                  :key="i"
                                  :value="schedule.staffId"
                                >
                                  <v-list-item-title v-text="schedule.staffName"></v-list-item-title>
                                </v-list-item>
                              </v-list>
                            </v-card>
                          </v-col>
                        </v-col> -->
                    </v-row>

                </v-container>
            </v-card-text>
            <v-card-actions v-if="this.isDisabledElemsOnStaff">
                <v-btn
                    v-show="staffCanDelete"
                    class="red darken-2 white--text"
                    text
                    @click="deleteShift(eventData.shiftId)"
                    :loading="delShift_btn_loader"
                    :disabled="delShift_btn_loader"
                >
                    Delete
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn v-if="eventData.status === '0'" class="blue darken-2 white--text" text @click="publishScheduleShift()"
                       :loading="updateShift_btn_loader"
                       :disabled="updateShift_btn_loader"
                >
                    Publish
                </v-btn>
                <v-btn
                  v-else
                  v-show="staffCanEdit"
                  class="blue darken-2 white--text"
                  text
                  @click="updateScheduleShift()"
                  :loading="updateShift_btn_loader"
                  :disabled="updateShift_btn_loader"
                >
                    Update
                </v-btn>
                <v-btn text color="blue darken-1" @click="clearData">Close</v-btn>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import moment_timezone from 'moment-timezone'

const url = require("../../client_config/config").url;
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'
import TimePicker from "@/components/DateTimePickers/TimePicker.vue";
import DatePicker from "@/components/DateTimePickers/DatePicker.vue";
import Swal from "sweetalert2";

export default {
    components: {DatePicker, TimePicker},
    props: {
        updateClose: Function,
        titleForm: String,
        staff: Array,
        clients: Array,
        houses: Array,
        eventData: Object,
        selectedOpen: Boolean,
        isDisabledElemsOnStaff: Boolean,
    },
    mixins: [validationMixin],
    validations: {
        //: { required },
        HouseId: {required},
        ClientId: {required},
        ServiceCode: {required},
    },
    data: () => ({
        msg: false,
        text: "",
        color: "success",
        StaffId: null,
        Supervisor: null,
        isForTraining: "",
        isRecurringEvent: "",
        calendarMenu: false,
        calendar2Menu: false,
        optionsForRecurring: ['Daily', 'Weekly', 'Monthly', 'Annually'],
        selectedOption: "",
        search: null,
        staffSelected: null,
        staffSelectedForMeeting: "",
        ClientId: null,
        HouseId: 0,
        notes: "",
        status: 0,
        startDatetime: new Date(),
        clientsUnderSelectedProgram: [],
        endDatetime: new Date(
            new Date().setTime(new Date().getTime() + 1 * 60 * 60 * 1000)
        ),
        textFieldProps: {
            appendIcon: "event"
        },
        startDateProps: {
            //min: moment(new Date()).format("YYYY-MM-DD")
        },
        startTimeProps: {
            ampmInTitle: true
        },
        endDateProps: { },
        endTimeProps: { },
        availableStaff: [],
        scheduledStaff: [],
        availableStaffinTraining: [],
        scheduledStaffinTraining: [],
        isShowing: true,
        staffName: '',
        assignedTask: '',
        tasks: [],
        task: null,
        requiredField: '',
        date: null,
        HouseName: [],
        ServiceCode: "",
        serviceCodes: [],

        delShift_btn_loader: false,
        updateShift_btn_loader: false,
        userState: localStorage.getItem("userState"),
        userRole: localStorage.getItem('userRole'),
        startShiftDate: '',
        startShiftTime: '',
        endShiftDate: '',
        endShiftTime: '',
        startShiftDateProps: '',
        startShiftTimeProps: '',
        endShiftDateProps: '',
        endShiftTimeProps: '',
        staffCanEdit: true,
        staffCanDelete: true,
        staffRequiresSupervision: false,
    }),
    async created() {

       this.initializedDateAndTime();
        //await this.getHouseId();

        if(this.userRole === 'Shift Lead' || this.userRole === 'Direct Care Staff'){
          this.staffCanEdit = false;
          this.staffCanDelete = false;
        }
    },

    async mounted() {
        // await this.getEventData()
        await this.initFormData(this.eventData);
    },

    computed: {
        /*
        staffErrors () {
          const errors = []
          if (!this.$v.StaffId.$dirty) return errors
          !this.$v.StaffId.required && errors.push('Staff is required')
          return errors
        },*/


        houseErrors() {
            const errors = []
            if (!this.$v.HouseId.$dirty) return errors
            !this.$v.HouseId.required && errors.push('House/Unit is required')
            return errors
        },

        clientErrors() {
            const errors = []
            if (!this.$v.ClientId.$dirty) return errors
            !this.$v.ClientId.required && errors.push('Client(s) is required')
            return errors
        },

        ServiceCodeErrors() {
            const errors = []
            if (!this.$v.ServiceCode.$dirty) return errors
            !this.$v.ServiceCode.required && errors.push('Service is required')
            return errors
        },

        resultQueryStaffTraining() {
            if (this.search) {
                return this.availableStaffinTraining.filter((item) => {
                    return this.search.toLowerCase().split(' ').every(v => item.Name.toLowerCase().includes(v))
                })
            } else {
                return this.availableStaffinTraining;
            }
        },

        resultQueryStaff() {
            if (this.search) {
                return this.availableStaff.filter((item) => {
                    return this.search.toLowerCase().split(' ').every(v => item.Name.toLowerCase().includes(v))
                })
            } else {
                return this.availableStaff;
            }
        },


    },

    watch: {
        selectedOpen (open) {
            !open ? this.clearData() : open
            console.log({open});
        },

         async eventData(nval) {
            await this.initFormData(nval);


            // this.startShiftDateProps = moment(nval.utcStartDate).format('YYYY-MM-DD');
            // this.startShiftTimeProps = moment(nval.utcStartDate).format('hh:mm A');
            // this.endShiftDateProps = moment(nval.utcEndDate).format('YYYY-MM-DD');
            // this.endShiftTimeProps = moment(nval.utcEndDate).format('hh:mm A');
            // this.startShiftDate = this.startShiftDateProps;
            // this.startShiftTime = this.startShiftTimeProps;
            // this.endShiftDate = this.endShiftDateProps;
            // this.endShiftTime = this.endShiftTimeProps;
            //
            //
            // this.StaffId = nval.staffId;
            // this.Supervisor = nval.supervisor;
            // this.ClientId = nval.clientId;
            // this.staffSelected = nval.staffId;
            // this.HouseId = nval.houseId;
            // this.ServiceCode = nval.serviceCode;
            // this.startDatetime = new Date(nval.startShift);
            // this.endDatetime = new Date(nval.endShift);
            // this.notes = nval.notes;
            // this.task = nval.task;
            // this.status = nval.status;
            // this.isForTraining = nval.isForTraining;
            // this.selectedOption = nval.selectedOption;
            // this.startDateOfRecurringEvent = (nval.startDateOfRecurringEvent !== null) ? moment(new Date(nval.startDateOfRecurringEvent)).format("YYYY-MM-DD") : null;
            // this.endDateOfRecurringEvent = (nval.endDateOfRecurringEvent !== null) ? moment(new Date(nval.endDateOfRecurringEvent)).format("YYYY-MM-DD") : null;
            // this.isRecurringEvent = nval.isRecurringEvent;
            //
            // if (this.HouseId) {
            //     this.HouseName = this.houses.filter((house) => house._id === this.eventData.houseId).map((house) => house.Name);
            //     if (this.HouseName.toString() !== "") await this.getClientsByUnit(this.HouseName);
            // }
            //
            // this.endDateProps = {
            //     min: moment(new Date(nval.startShift)).format("YYYY-MM-DD")
            // }
            // this.endTimeProps = {
            //     min: moment(new Date(nval.startShift)).format("HH:MM")
            // }
            //
            // await this.getTasks();
        },

        async startDatetime(nval) {

           this.endDateProps = {
              min: moment(new Date(nval)).format("YYYY-MM-DD")
            }
          /*
            this.endTimeProps = {
              min: moment(new Date(nval)).format("HH:MM")
            }
          */

            if (this.isForTraining === "Yes") {
                await this.getStaffForMeeting(nval, this.endDatetime);
            } else {
                if (this.HouseId) {
                    this.HouseName = this.houses.filter((house) => house._id === this.eventData.houseId).map((house) => house.Name);
                }
                await this.getDefaultStaff(nval, this.endDatetime);
            }


        },

        async endDatetime(nval) {
            //this.getDefaultStaff(this.startDatetime, nval);
            if (this.isForTraining === "Yes") {
                await this.getStaffForMeeting(this.startDatetime, nval);
            } else {
                if (this.HouseId) {
                    this.HouseName = this.houses.filter((house) => house._id === this.eventData.houseId).map((house) => house.Name);
                }
                await this.getDefaultStaff(this.startDatetime, nval);
            }
        },

        async HouseId(val) {
            let houseName = "";

            houseName = this.houses.filter((house) => house._id === val).map((house) => house.Name);

            if (houseName.toString() !== "") {
                houseName.toString() !== this.HouseName.toString() ? this.ClientId = [] : this.ClientId = this.eventData.clientId;
                await this.getClientsByUnit(houseName);
            }
        },

    },

    methods: {

        async showErrorNotification(message) {
            this.msg = true;
            this.text = message;
            this.color = 'error';
            this.updateShift_btn_loader = false;
        },

        async getDefaultStaff(start, end, houseName = this.HouseName) {
            this.isShowing = false;
            let available = [];
            let schedule = [];

            this.availableStaff = [];
            this.scheduledStaff = [];

            await axios.get(`${url}/shifts/available/${houseName}/${this.userState}`, {
                params: {
                    StartDate: start,
                    EndDate: end
                }
            })
                .then(response => {
                    available = response.data.available;

                    if (response.data.schedule !== undefined) {
                        response.data.schedule.forEach(item => {
                            if (item.employee != null) {
                                if (item.employee.State === this.userState) {
                                    const {employee} = item;
                                    if (item._id === this.eventData.shiftId) {
                                        this.staffRequiresSupervision = employee?.RequiresSupervision || '';
                                        this.staffName = employee?.Name || '';
                                    }
                                    schedule.push({
                                        _id: item.id,
                                        staffName: employee?.Name || '',
                                        staffId: employee?._id || '',
                                        staffRequiresSupervision: employee?.RequiresSupervision || '',
                                    });
                                }
                            }
                        })
                    }

                    schedule = [...new Map(schedule.map((employee) => [employee.staffId, employee])).values()];
                })
                .finally(() => {
                    this.isShowing = true;
                    this.isForTraining === "Yes" ? this.availableStaffinTraining = available : this.availableStaff = available;

                    this.scheduledStaff = schedule;
                });
        },
        /*
        async getHouseId() {
          await axios.get(`${url}/units`).then((res) => {
            res.data.units.forEach((item) => {
              if(item._id == this.HouseId){
                this.HouseName = item.Name;
                this.getClientsByUnit(this.HouseName);
              }
            });
          });
        },
        */
        async getEventData() {
            this.StaffId = this.eventData.staffId;
            this.ClientId = this.eventData.clientId;
            this.staffSelected = this.eventData.staffId;
            this.HouseId = this.eventData.houseId;
            this.startDatetime = new Date(this.eventData.startShift);
            this.endDatetime = new Date(this.eventData.endShift);
            this.notes = this.eventData.notes;
            this.status = this.eventData.status;
            this.task = this.eventData.task;
            this.isForTraining = this.eventData.isForTraining;
            this.isRecurringEvent = this.eventData.isRecurringEvent;
            this.selectedOption = this.eventData.selectedOption;
            this.ServiceCode = this.eventData.serviceCode;

            this.startDateOfRecurringEvent = (this.eventData.startDateOfRecurringEvent !== null) ? moment(new Date(this.eventData.startDateOfRecurringEvent)).format("YYYY-MM-DD") : null;
            this.endDateOfRecurringEvent = (this.eventData.endDateOfRecurringEvent !== null) ? moment(new Date(this.eventData.endDateOfRecurringEvent)).format("YYYY-MM-DD") : null;

            if (this.HouseId) {
                this.HouseName = this.houses.filter((house) => house._id == this.eventData.houseId).map((house) => house.Name);
                if (this.HouseName.toString() != "") await this.getClientsByUnit(this.HouseName);
            }

            this.getTasks()
        },

        async initFormData(eventData) {

            this.startShiftDateProps = moment(eventData.utcStartDate).format('YYYY-MM-DD');
            this.startShiftTimeProps = moment(eventData.utcStartDate).format('hh:mm A');
            this.endShiftDateProps = moment(eventData.utcEndDate).format('YYYY-MM-DD');
            this.endShiftTimeProps = moment(eventData.utcEndDate).format('hh:mm A');
            this.startShiftDate = this.startShiftDateProps;
            this.startShiftTime = this.startShiftTimeProps;
            this.endShiftDate = this.endShiftDateProps;
            this.endShiftTime = this.endShiftTimeProps;


            this.StaffId = eventData.staffId;
            this.ClientId = eventData.clientId;
            this.staffSelected = eventData.staffId;
            this.HouseId = eventData.houseId;
            this.ServiceCode = eventData.serviceCode;
            this.startDatetime = new Date(eventData.startShift);
            this.endDatetime = new Date(eventData.endShift);
            this.notes = eventData.notes;
            this.task = eventData.task;
            this.status = eventData.status;
            this.isForTraining = eventData.isForTraining;
            this.selectedOption = eventData.selectedOption;
            this.startDateOfRecurringEvent = (eventData.startDateOfRecurringEvent !== null) ? moment(new Date(eventData.startDateOfRecurringEvent)).format("YYYY-MM-DD") : null;
            this.endDateOfRecurringEvent = (eventData.endDateOfRecurringEvent !== null) ? moment(new Date(eventData.endDateOfRecurringEvent)).format("YYYY-MM-DD") : null;
            this.isRecurringEvent = eventData.isRecurringEvent;

            if (this.HouseId) {
                this.HouseName = this.houses.filter((house) => house._id === this.eventData.houseId).map((house) => house.Name);
                if (this.HouseName.toString() !== "") await this.getClientsByUnit(this.HouseName);
            }

            this.endDateProps = {
                min: moment(new Date(eventData.startShift)).format("YYYY-MM-DD")
            }
            this.endTimeProps = {
                min: moment(new Date(eventData.startShift)).format("HH:MM")
            }

            await this.getTasks();
        },

        async getTasks() {
            // const startDate = moment().startOf('day').toISOString();
            // const endDate = moment().endOf('day').toISOString();

            this.getServiceCodes();

            let timezone = "";

            let startDate = moment_timezone.tz(moment().startOf('day').toISOString(), timezone)
            let endDate = moment_timezone.tz(moment().endOf('day').toISOString(), timezone)

            let clientIds = this.ClientId.map(client => {
                return client._id != undefined ? client._id : client
            })

            await axios.get(`${url}/calendar/tasks?startDate=${startDate}&endDate=${endDate}&client=${clientIds.toString()}`).then(response => {
                this.tasks = response.data.tasks;
            });
        },

        async getServiceCodes() {
              this.serviceCodes = [];
              axios.get(`${url}/serviceCodes/client/${this.ClientId}`).then(res => {
                console.log(res.data.serviceCodes);
                this.serviceCodes = res.data.serviceCodes.map(item => {
                  return {
                    _id: item.Name,
                    Name: item.Name
                  }
                });
              });
            },

        async getClientsByUnit(houseName) {
            this.clientsUnderSelectedProgram = []
            await axios.get(`${url}/clients/house/${houseName.toString()}`).then((res) => {
                res.data.clients.forEach((item) => {
                    this.clientsUnderSelectedProgram.push(item);
                });
            }).catch(error => {
                console.log(error.response.data.msg);
            });

            await this.getDefaultStaff(this.startDatetime, this.endDatetime, houseName);
        },

        getStaffForMeeting: async function (start, end) {
            this.isShowing = false;
            let available = [];
            let schedule = [];
            this.scheduledStaffinTraining = [];
            this.availableStaffinTraining = [];
            await axios.get(`${url}/shifts/available/${this.userState}`, {
                params: {
                    StartDate: start,
                    EndDate: end
                }
            }).then(async res => {
                available = res.data.available;
                //schedule = res.data.schedule;
                await res.data.schedule.forEach(item => {
                    if (item.employee.State === this.userState) {
                        const {employee} = item;
                        if (item._id === this.eventData.shiftId) {
                            this.staffName = employee?.Name || '';
                        }

                        schedule.push({
                            _id: item.id,
                            staffName: employee?.Name || '',
                            staffId: employee?._id || '',
                        });
                    }
                })

                schedule = [...new Map(schedule.map((employee) => [employee.staffId, employee])).values()];
            }).finally(() => {
                this.isShowing = true;
                this.availableStaffinTraining = available;
                this.scheduledStaffinTraining = schedule;
            });
        },


        async updateScheduleShift() {
            this.updateShift_btn_loader = true;
            if (!this.startShiftDate || !this.startShiftTime || !this.endShiftDate || !this.endShiftTime) {
                this.showErrorNotification('Please provide shift start and end dates');
                this.updateShift_btn_loader = false;
                return;
            }

            this.startDatetime = new Date(`${this.startShiftDate} ${this.startShiftTime}`);
            this.endDatetime = new Date(`${this.endShiftDate} ${this.endShiftTime}`);

            if (this.$refs.form.validate()) {

                if (moment(this.startDatetime).isSameOrAfter(this.endDatetime)) {
                  this.showErrorNotification('Shift End time should be greater than Start time.');
                  return false;
                }

                let req_body = {
                    ClientId: this.ClientId,
                    EmployeeId: this.StaffId,
                    isTraining: this.isForTraining,
                    AvailableStaff: this.staffSelected,
                    HouseName: this.HouseName,
                    HouseId: this.HouseId,
                    StartDate: this.startDatetime,
                    EndDate: this.endDatetime,
                    Notes: this.notes,
                    Task: this.task,
                    Status: this.status,
                    typeOfRecurringEvent: this.selectedOption,
                    ServiceCode: this.ServiceCode,
                     tz: moment_timezone.tz.guess(),
                };

              try {
                await axios.put(`${url}/shifts/${this.eventData.shiftId}`, req_body);
                this.msg = true;
                this.text = "Schedule updated successfully.";
                this.color = "success";
                let emitValue = {msg: this.msg, text: this.text, color: this.color, selectedOpen: false};
                this.$emit('updateSchedule', emitValue);
              } catch (err) {
                if (err.response) {
                  this.text = err.response.data?.msg || "An error occurred.";
                  this.color = "error";
                } else {
                  this.text = "Network error or server not reachable.";
                  this.color = "error";
                }
                let emitValue = {msg: true, text: this.text, color: this.color, selectedOpen: true};
                this.$emit('updateSchedule', emitValue);
              } finally {
                this.updateShift_btn_loader = false;
              }
            } else {
                this.updateShift_btn_loader = false;
            }
        },


        async publishScheduleShift() {
            this.updateShift_btn_loader = true;

            this.startDatetime = new Date(`${this.startShiftDate} ${this.startShiftTime}`);
            this.endDatetime = new Date(`${this.endShiftDate} ${this.endShiftTime}`);

            if (this.$refs.form.validate()) {
                if (moment(this.startDatetime).isSameOrAfter(this.endDatetime)) {
                    this.showErrorNotification('Shift End time should be greater than Start time.');
                    return false;
                }

                var req_body = {
                    Status: 1,
                    StartDate: this.startDatetime,
                    EndDate: this.endDatetime,
                    HouseId: this.HouseId,
                    EmployeeId: this.StaffId,
                    ClientId: this.ClientId,
                    AvailableStaff: this.staffSelected,
                    Notes: this.notes,
                    Task: this.task,
                    typeOfRecurringEvent: this.selectedOption,
                    ServiceCode: this.ServiceCode,
                    tz: moment_timezone.tz.guess()
                };

                try {
                    await axios.put(`${url}/shifts/${this.eventData.shiftId}`, req_body)

                    this.msg = true;
                    this.text = "Schedule published successfully.";
                    this.color = "success";
                    let emitValue = {msg: this.msg, text: this.text, color: this.color, selectedOpen: false}
                    this.updateShift_btn_loader = false;

                    this.$emit('updateSchedule', emitValue);
                } catch (err) {
                    if (err.response) {
                        this.text = err.response.data.msg;
                        this.msg = true;
                        this.color = "error";
                        let emitValue = {msg: this.msg, text: this.text, color: this.color, selectedOpen: true}
                        this.updateShift_btn_loader = false;

                        this.$emit('updateSchedule', emitValue);
                    }
                }
            }
        },



        async deleteShift(shiftId) {
            confirm("Are you sure you want to delete this shift?") &&
            this.shiftDelete(shiftId);

        },

        async shiftDelete(id) {
            this.delShift_btn_loader = true
            await axios.delete(`${url}/shifts/${id}`)
                .then((response) => {
                    if (response.status === 400) {
                        response.json().then(function (data) {
                            this.msg = true;
                            this.text = data.msg;
                        });
                    }
                    this.msg = true;
                    this.text = "The shift has been deleted successfully.";
                    this.color = "success";
                    let emitValue = {msg: this.msg, text: this.text, color: this.color, selectedOpen: false};
                    this.delShift_btn_loader = false;

                    this.$emit('deleteSchedule', emitValue);
                });
        },

        initializedDateAndTime() {
            this.startShiftDateProps = moment(this.eventData.utcStartDate).format('YYYY-MM-DD');
            this.startShiftTimeProps = moment(this.eventData.utcStartDate).format('hh:mm A');
            this.endShiftDateProps = moment(this.eventData.utcEndDate).format('YYYY-MM-DD');
            this.endShiftTimeProps = moment(this.eventData.utcEndDate).format('hh:mm A');
            this.startShiftDate = this.startShiftDateProps;
            this.startShiftTime = this.startShiftTimeProps;
            this.endShiftDate = this.endShiftDateProps;
            this.endShiftTime = this.endShiftTimeProps;
        },

        clearData() {
            this.updateClose();
            this.getEventData();
        },

        isDisabledElementsOnStaff () {
            return this.isDisabledElemsOnStaff ? false : true
        },

        checkSupervision(staff) {
            if (staff.RequiresSupervision) {
                Swal.fire({
                    title: 'Confirm Assignment',
                    text: 'Are you sure you want to assign this staff? The staff\'s background is still not cleared.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Assign Anyway',
                    cancelButtonText: 'Choose Other'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.staffSelected = staff;
                    } else {
                        this.staffSelected = this.availableStaff[0];
                    }
                });
            } else {
                this.staffSelected = staff;
            }
        },
    }
}
</script>
<style scoped>
.v-application {
    justify-content: center;
}

 .form-size {
     width: 90vw;
     height: 90vh;
     max-width: 100%;
     max-height: 100%;
     overflow: auto;
     margin: auto;
 }

@media (max-width: 600px) {
    .form-size {
        width: 100vw;
        height: 100vh;
    }
}

</style>
